import { Platform } from 'react-native';

// native driver is not available on the web, it should always be set to false there
// this will be true for mobile platforms: android & ios
export const nativeDriverValue = Platform.OS !== 'web';
// this specific 'cache-control:no-cache' header is automatically added on the web
// to avoid the failure in executing the request on the web we will not send it
export const cacheControlHeader = Platform.OS !== 'web' ? { 'Cache-Control': 'no-cache' } : null;
// show scrollIndicator for the web platform only
export const showScrollIndicator = Platform.OS === 'web';

// max width for the web platform
export const MAX_WEB_WIDTH = 1216;

export const isWeb = Platform.OS === 'web';
export const isIos = Platform.OS === 'ios';
export const isAndroid = Platform.OS === 'android';

// modal paddings for the web platform
export const MODAL_PADDINGS = 64;
export const VERTICAL_MODAL_PADDINGS = 96; // includes "x" button height
export const PRODUCT_SWITCHER_HEIGHT = 52;

// max width for desktop web used on casino web
// TODO would consolidate with MAX_WEB_WIDTH in the future
export const MAX_DESKTOP_WEB_WIDTH = 1280;
// horizontal page margin on each side of the desktop web containers
export const DESKTOP_PAGE_MARGIN = 80;
// gap between the desktop header and the page content, and where the sticky side rail comes to rest
export const DESKTOP_CONTENT_TOP_GAP = 32;
// side rail sits flush with the left edge of the capped page container
export const SIDE_RAIL_WIDTH = 208;
// gap between the side rail and the content column
export const SIDE_RAIL_CONTENT_GAP = 28;
